import magentaOAuth from "./lib/auth-ts/magentaOAuth.ts";
import config from './config.js'

const GOOGLE_KEY_ANALYTICS = config.googleApiKeyAnalytics()

function init(){
    window.dataLayer = window.dataLayer || []
    
    function gtag() {
        dataLayer.push(arguments)
    }
    gtag('js', new Date())
    gtag('config', GOOGLE_KEY_ANALYTICS)
}
function googleAnalytics() {
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_KEY_ANALYTICS}`
    document.querySelector("head").appendChild(script);
    init()
}

function checkTokenIsActive() {
    return new Promise((resolve, reject) => {
        //Existe token?
        const token = localStorage.getItem('ACCESS_TOKEN')
        //Valido que este activo
        if (token) {
            magentaOAuth
                .active()
                .then(response => {
                    googleAnalytics()
                    resolve(response)
                })
                .catch(err => {
                    console.log('error ', err)
                    reject()
                })
        } else {
            resolve(false)
        }
    })
}
checkTokenIsActive()

export default googleAnalytics